import { Action } from '@ngrx/store';
import { AdvertiserActions, AdvertiserActionsTypesNgrx } from './advertisers.action';
import { Advertiser } from './../../models/advertiser';

export  const FeatureStateName = 'AdvertisersStateFromModule';

export enum AdvertisersStateEnum {
  LOADING= 'LOADING',
  LOADED= 'LOADED',
  ERROR= 'ERROR',
  INITIAL= 'INITIAL',
  NEW= 'NEW',
  EDIT= 'EDIT',
  UPDATED= 'UPDATED'
}

export interface AdvertisersState {

  advertisers: Array<Advertiser>;
  selectAdvertiser: Advertiser | null;
  errorMessage: string;
  dataStateNgrx: AdvertisersStateEnum;
  currentAdvertiser: Advertiser|null;
  currentAction: AdvertiserActions|null;
}

const initState: AdvertisersState = {
  advertisers: [],
  selectAdvertiser: null,
  errorMessage: '',
  dataStateNgrx: AdvertisersStateEnum.INITIAL,
  currentAdvertiser: null,
  currentAction:null

};

export function advertisersReducer (state: AdvertisersState= initState, action: Action): AdvertisersState {

    switch (action.type) {

    /*Get ADVERTISER*/
    case AdvertiserActionsTypesNgrx.GET_ALL_ADVERTISER:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADING, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.GET_ALL_ADVERTISER_SUCCESS:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADED, advertisers: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.GET_ALL_ADVERTISER_ERROR:
    return {...state, dataStateNgrx : AdvertisersStateEnum.ERROR, errorMessage: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};

    /*Get SEARCH ADVERTISER*/
    case AdvertiserActionsTypesNgrx.SEARCH_ADVERTISER:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADING};
    case AdvertiserActionsTypesNgrx.SEARCH_ADVERTISER_SUCCESS:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADED, advertisers: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.SEARCH_ADVERTISER_ERROR:
    return {...state, dataStateNgrx : AdvertisersStateEnum.ERROR, errorMessage: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};

    /*Get ADVERTISER BY NAME*/
    case AdvertiserActionsTypesNgrx.GET_ADVERTISER_BY_NAME:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADING};
    case AdvertiserActionsTypesNgrx.GET_ADVERTISER_BY_NAME_SUCCESS:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADED, currentAdvertiser: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.GET_ADVERTISER_BY_NAME_ERROR:
    return {...state, dataStateNgrx : AdvertisersStateEnum.ERROR, errorMessage: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};

    /*Get NEW ADVERTISER*/
    case AdvertiserActionsTypesNgrx.NEW_ADVERTISER:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADING, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.NEW_ADVERTISER_SUCCESS:
    return {...state, dataStateNgrx : AdvertisersStateEnum.NEW, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.NEW_ADVERTISER_ERROR:
    return {...state, dataStateNgrx : AdvertisersStateEnum.ERROR, errorMessage: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};

    /*Get SAVE ADVERTISER*/
    case AdvertiserActionsTypesNgrx.SAVE_ADVERTISER:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADING, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.SAVE_ADVERTISER_SUCCESS:
      const prods: Advertiser[] = [...state.advertisers];
      prods.push((<AdvertiserActions>action).payload);
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADED, advertisers: prods, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.SAVE_ADVERTISER_ERROR:
    return {...state, dataStateNgrx : AdvertisersStateEnum.ERROR, errorMessage: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};

    /*Get EDIT ADVERTISER*/
    case AdvertiserActionsTypesNgrx.EDIT_ADVERTISER:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADING, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.EDIT_ADVERTISER_SUCCESS:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADED, currentAdvertiser: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.EDIT_ADVERTISER_ERROR:
    return {...state, dataStateNgrx : AdvertisersStateEnum.ERROR, errorMessage: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};

    /*Get UPDATE ADVERTISER*/
    case AdvertiserActionsTypesNgrx.UPDATE_ADVERTISER:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADING, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.UPDATE_ADVERTISER_SUCCESS:
    const advertiserUpdated: Advertiser = (<AdvertiserActions>action).payload;
    const advertiserListUpdatedt = state.advertisers.map(p => (p._id === advertiserUpdated._id) ? advertiserUpdated : p);
    return {...state, dataStateNgrx : AdvertisersStateEnum.UPDATED, advertisers: advertiserListUpdatedt, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.UPDATE_ADVERTISER_ERROR:
    return {...state, dataStateNgrx : AdvertisersStateEnum.ERROR, errorMessage: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};


    /*Get DELETE ADVERTISER*/
    case AdvertiserActionsTypesNgrx.DELETE_ADVERTISER:
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADING, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.DELETE_ADVERTISER_SUCCESS:
    const advertiserDelete: Advertiser = (<AdvertiserActions>action).payload;
    const index = state.advertisers.indexOf(advertiserDelete);
    const list = [...state.advertisers];
    list.splice(index, 1);
    const dataSource: Advertiser[] = list.map(p => p._id === advertiserDelete._id ? advertiserDelete : p);
    return {...state, dataStateNgrx : AdvertisersStateEnum.LOADED, advertisers: dataSource, currentAction: <AdvertiserActions>action};
    case AdvertiserActionsTypesNgrx.DELETE_ADVERTISER_ERROR:
    return {...state, dataStateNgrx : AdvertisersStateEnum.ERROR, errorMessage: (<AdvertiserActions>action).payload, currentAction: <AdvertiserActions>action};

    default : return {...state};
  }
}
